import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ErrorSummaryComponent } from '../error-summary/error-summary.component';
import { ErrorMessage } from '../models/error-message.model';
import { Tenant } from '../models/tenant.model';
import { IdentificationService } from '../shared/identification.service';
import { ViewModelService } from '../shared/view-model.service';

@Component({
   selector: 'app-steptwo',
   standalone: true,
   imports: [ErrorSummaryComponent, FormsModule],
   templateUrl: './steptwo.component.html',
   styleUrl: './steptwo.component.scss',
})
export class SteptwoComponent implements OnInit {
   tenants: Tenant[] = [];

   public vm = inject(ViewModelService);
   private idvService = inject(IdentificationService);
   private router = inject(Router);

   ngOnInit(): void {
      this.idvService.getTenants().subscribe({
         next: (tenants) => {
            if (tenants != null) {
               this.tenants = tenants;
               this.vm.error = null;
               console.log('[IDV] Tenants loaded', this.tenants);

               const availableTenants = this.tenants.filter((o) => o.blocked === false && o.registered === false).length;

               console.log('[IDV] availableTenants', availableTenants);
               if (availableTenants > 0) {
                  if ((window as any).ga) {
                     (window as any).ga('send', 'event', {
                        eventCategory: 'ID&V',
                        eventLabel: 'Step Two',
                        eventAction: 'Tenants Available for ID&V',
                        eventValue: availableTenants,
                     });
                  }
               } else {
                  if ((window as any).ga) {
                     (window as any).ga('send', 'event', {
                        eventCategory: 'ID&V',
                        eventLabel: 'Step Two',
                        eventAction: 'No Tenants Available for ID&V',
                     });
                  }
               }
            } else {
               this.noTenantsError('');
            }
         },
         error: (error) => {
            this.noTenantsError(error.status);
         },
      });
   }

   private noTenantsError(errorStatus: string): void {
      if (!this.vm.content) return;

      if (errorStatus === '401') {
         if ((window as any).ga) {
            (window as any).ga('send', 'event', {
               eventCategory: 'ID&V',
               eventLabel: 'Step Two',
               eventAction: 'Portal not Available',
            });
         }
         this.vm.error = new ErrorMessage(this.vm.content.stepAbortPortalNotAvailableTitle, this.vm.content.stepAbortPortalNotAvailableMessage);
      } else {
         if ((window as any).ga) {
            (window as any).ga('send', 'event', {
               eventCategory: 'ID&V',
               eventLabel: 'Step Two',
               eventAction: 'No Tenants Found',
            });
         }
         this.vm.error = new ErrorMessage(this.vm.content.step2NoTenantsTitle, this.vm.content.step2NoTenantsDescription);
      }
   }

   processRegisteredMessage(tenant: Tenant): string {
      if (!this.vm.content) return '';
      return this.vm.content.step2TenantAlreadyRegistered.split('**name**').join(tenant.firstName + ' ' + tenant.lastName);
   }

   goBack(): void {
      this.router.navigate(['stepone-confirm']);
   }

   goNext(): void {
      this.router.navigate(['stepthree']);
   }

   selectTenant(tenant: Tenant): void {
      this.vm.selectedContactId = tenant.contactId;
   }
}
